// extracted by mini-css-extract-plugin
export default {"page":"tg-z","cartModal":"ug-z","checkout":"vg-z","placeholder":"wg-z","account":"xg-z"};